function loadJSSDKScript() {
  return new Promise((resolve, reject) => {
    if (window.tt) {
      resolve(window.tt);
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://lf1-cdn-tos.bytegoofy.com/goofy/developer/jssdk/jssdk-1.2.0.js';
    script.onload = () => {
      resolve(window.tt);
    };
    script.onerror = reject;
    document.body.appendChild(script);
  });
}

const tt = {
  navigateBack(delta = 1) {
    loadJSSDKScript().then((ttBridge) => {
      ttBridge.miniProgram.navigateBack({
        delta,
      });
    });
  },
  call(phoneNumber) {
    loadJSSDKScript().then((ttBridge) => {
      ttBridge.miniProgram.navigateTo({
        url: '/pages/makePhoneCall/index',
        query: {
          phoneNumber,
        },
      });
    });
  },
};

export default tt;
